import { numberWithCommas } from './formatters';

const LabelMapper = {
  total: 'Total',
  revenue: 'Revenue',
  ratesAndAnnualCharges: 'Rates and annual charges',
  userChargesAndFees: 'User charges and fees',
  interestAndInvestmentRevenue: 'Interest and investment revenue',
  otherRevenue: 'Other revenue',
  grantsAndContributionsProvidedForOperating:
    'Grants and contributions provided for operating purposes',
  grantsAndContributionsProvidedForCapital:
    'Grants and contributions provided for capital purposes',
  netGainsFromTheDisposalsOfAssets: 'Net gains from the disposal of assets',
  NetShareOfInterestsInJointVenturesAndAssociates:
    'Net share of interests in joint ventures and associates',
  expenses: 'Expenses',
  employeeBenefitsAndOnCosts: 'Employee benefits and on costs',
  borrowingCosts: 'Borrowing costs',
  materialsAndContracts: 'Materials and contracts',
  depreciationAndAmortisation: 'Depreciation and amortisation',
  impairment: 'Impairment',
  otherExpenses: 'Other expenses',
  netLossesFromDisposalOfAssets: 'Net losses from disposal of assets',
  gainLossForChangeInAssetsHeldAtFairValueThroughProfitOrLoss:
    'Gain / (loss) for a change in assets held at fair value through profit or loss',
  operatingResult: 'Operating result',
  assets: 'Assets',
  currentAssets: 'Current assets',
  nonCurrentAssets: 'Non-current assets',
  miscellaneousNonCurrentAssets: 'Miscellaneous non-current assets',
  liabilities: 'Liabilities',
  currentLiabilities: 'Current liabilities',
  nonCurrentLiabilities: 'Non-current liabilities',
  miscellaneousCurrentLiabilities: 'Miscellaneous current liabilities',
  miscellaneousNonCurrentLiabilities: 'Miscellaneous non-current liabilities',
  operatingPerformance: 'Operating performance',
  ownSourceOperatingRevenue: 'Own source operating revenue',
  unrestrictedCurrentRatio: 'Unrestricted current ratio',
  debtServiceCoverRatio: 'Debt  service cover ratio',
  ratesAndAnnualChargesOutstandingPercentage:
    'Rates and annual charges outstanding percentage',
  cashExpenseCoverRatio: 'Cash expense cover ratio',
  ordinaryRates: 'Ordinary rates',
  specialRates: 'Special rates',
  annualCharges: 'Annual charges',
  specificUserCharges: 'Specific user charges',
  statutoryAndRegulatoryCharges: 'Statutory and regulatory charges',
  otherCharges: 'Other charges',
  cashAndCashEquivalents: 'Cash and cash equivalents',
  currentInvestments: 'Current investments',
  currentReceivables: 'Current receivables',
  currentInventories: 'Current inventories',
  otherCurrentAssets: 'Other current assets',
  nonCurrentAssetsHeldForSale: 'Non-current assets held for sale',
  nonCurrentInvestments: 'Non-current investments',
  nonCurrentReceivables: 'Non-current receivables',
  nonCurrentInventories: 'Non-current inventories',
  payablesNonCurrentLiabilities: 'Non-current payables liability',
  infrastructurePropertyPlantAndEquipment:
    'Infrastructure property, plant and equipment',
  investmentsAccountedForUsingTheEquityMethod:
    'Investments cccounted for using the equity method',
  investmentProperty: 'Investment property',
  intangibleAssets: 'Intangible assets',
  currentPayables: 'Current payables',
  currentBorrowings: 'Current borrowings',
  currentProvisions: 'Current provisions',
  incomeReceivedInAdvance: 'Income received in advance',
  nonCurrentPayables: 'Non-current payables',
  nonCurrentBorrowings: 'Non-current borrowings',
  nonCurrentProvisions: 'Non-current provisions',
  // New for qld
  otherRevenues: 'Other revenues',
  capitalExpenses: 'Capital expenses',
  infrastructurePropertyPlantEquipment:
    'Infrastructure property, plant equipment',
  operatingSurplusRatio: 'Operating surplus ratio',
  grantsContributionsProvidedForOperating:
    'Grants contributions provided for operating',
  averageOsr: 'Average Operating surplus ratio',
  grantsContributionsProvidedForCapital:
    'Grants contributions provided for capital',
  miscellaneous: 'Miscellaneous',
  netFinancialLiabilities: 'Net financial liabilities',
  assetSustainabilityRatio: 'Asset sustainability ratio',
  averageAsr: 'Average Asset sustainability ratio',
  relativeRiskAssessment: 'Relative sisk assessment',
  averageRemainingUsefulLifeOfInfrastructureAssets:
    'Average remaining useful life of infrastructure assets',
  _trend: 'Should not be displayed',
  // new for health
  healthServiceFunding: 'Health service funding',
  grantsAndOtherContributions: 'Grants and other contributions',
  gainOnDisposalRevaluationOfAssets: 'Gain on disposal/revaluation of assets',
  employeeExpenses: 'Employee expenses',
  suppliesAndServices: 'Supplies and services',
  operatingCashOutflows: 'Operating cash outflows',
  grants: 'Grants',
  currentEmployeeProvision: 'Current employee provision',
  depreciationAndAmmortization: 'Depreciation and ammortization',
  impairmentLoss: 'Impairment loss',
  unrestrictedCash: 'Unrestricted cash',
  restrictedCash: 'Restricted cash',
  interestExpense: 'Interest expense',
  provisions: 'Provisions',
  unearnedRevenue: 'Unearned revenue',
  cashAvailableDays: 'Cash available days',
  retainedSurplusExpenditure: 'Retained surplus/expenditure',
  frontlineStaff: 'Frontline staff',
  nonFrontLineStaff: 'Non-frontline staff',
  qwau: 'QWAU',
  anticipatedMaintenance: `Anticipated maintenance`,
  activityBasedFuningAbf: 'Activity Based Funding (ABF)',

  // New for education
  commonwealthGovernmentFinancialAssistance:
    'Commonwealth Government financial assistance',
  hecsHelpStudentPayments: 'HECS/HELP student payments',
  feesAndCharges: 'Fees and charges',
  investmentRevenue: 'Investment revenue',
  royaltiesTrademarksAndLicences: 'Royalties, trademarks and licences',
  consultanciesAndContracts: 'Consultancies and contracts',
  stateAndLocalGovernmentFinancialAssistance:
    'State and local government financial assistance',
  otherIncome: 'Other income',
  investmentIncome: 'Investment income',
  profitLossOnInvestmentsAccountedForUsingTheEquityMethod:
    'Profit/loss on investments accounted for using the equity method',
  employeeRelatedExpenses: 'Employee-related expenses',
  repairsAndMaintenance: 'Repairs and maintenance',
  financeBorrowingCosts: 'Finance borrowing costs',
  impairmentOfAssets: 'Impairment of assets',
  shareOfLossOnInvestmentsAccountedForUsingTheEquityMethod:
    'Share of loss on investments accounted for using the equity method',
  lossOnDisposalOfAssets: 'Loss on disposal of assets',
  incomeTaxExpense: 'Income tax expenses',
  currentTradeAndOtherReceivables: 'Current trade and other receivables',
  currentContractAssets: 'Current contract assets',
  inventories: 'Inventories',
  otherFinancialAssets: 'Other financial assets',
  otherNonFinancialAssets: 'Other non-financial assets',
  propertyPlantAndEquipment: 'Property, plant and equipment',
  nonCurrentTradeAndOtherReceivables: 'Non-current trade and other receivables',
  investmentsAccountedForUsingEquityMethod:
    'Investments accounted for using the equity method',
  nonCurrentOtherFinancialAssets: 'Other non-current financial assets',
  otherNonCurrentAssets: 'Other non-current assets',
  currentContractLiabilities: 'Current contract liabilities',
  currentLeaseLiabilities: 'Current lease liabilities',
  otherLiabilities: 'Other liabilities',
  currentTradeAndOtherPayables: 'Current trade and other payables',
  nonCurrentTradeAndOtherPayables: 'Non-current trade and other payables',
  nonCurrentContractLiabilities: 'Non-current contract liabilities',
  nonCurrentLeaseLiabilities: 'Non-current lease liabilities',
  nonCurrentOtherLiabilities: 'Other non-current liabilities',
  ppEAdditions: 'Property, plant and equipment additions',
  staffFtEs: 'Staff (FTEs)',
  studentNumbersEftsl: '2022 student numbers (EFTSL)',
  studentStaffRatioEftslFte: '2022 student-staff ratio (EFTSL/FTE)',
  employeeExpensePerFte: 'Employee expense per FTE',
  unisDomesticStudents: 'Domestic students (EFTSL)',
  unisInternationalStudents: 'International students (EFTSL)',
  numberOfSchoolsCampusesInQld: 'Number of schools/campuses in Queensland',
  numberOfSchoolsCampusesOutsideQld:
    'Number of schools/campuses outside Queensland',
  tuitionAndBoardingFees: 'Tuition and boarding fees',
  donations: 'Donations',
  interestInvestmentIncome: 'Interest/investment income',
  userCharges: 'User charges',
  increaseDecreaseInAssetRevaluationSurplus:
    'Increase/(decrease) in asset revaluation surplus',
  receivables: 'Receivables',
  rightOfUseAssets: 'Right-of-use assets',
  payables: 'Payables',
  leaseLiabilities: 'Lease liabilities',
  financialLiabilities: 'Financial liabilities',
  accruedEmployeeBenefits: 'Accrued employee benefits',
  appropriationRevenue: 'Appropriation revenue',
  interest: 'Interest',
  salesOfGoodsAndServices: 'Sales of goods and services',
  shareOfProfitsOfJointVenturesAccountedForUsingTheEquityMethod:
    'Share of profits of joint ventures accounted for using the equity method',
  impairmentLosses: 'Impairment losses',
  grantsAndSubsidies: 'Grants and subsidies',
  lossesOnDisposalRemeasurementOfAssets:
    'Losses on disposal/remeasurement of assets',
  revaluationDecrement: 'Revaluation decrement',
  incomeTaxExpenses: 'Income tax expenses',
  transfersOfAdministeredIncomeToGovernment:
    'Transfers of administered income to government',
  prepayments: 'Prepayments',
  cashAtBank: 'Cash at bank',
  appropriationReceivable: 'Appropriation receivable',
  gstInputTaxCreditsReceivable: 'GST input tax credits receivable',
  tradeReceivableCurrentAssets: 'Trade receivable',
  interestBearingLiabilities: 'Interest bearing liabilities',
  gstPayable: 'GST payable',
  overdraftFacilities: 'Overdraft facilities',
  revenuePayableToGovernment: 'Revenue payable to government',
  averageInternetSpeedPerStudent:
    'Internet speed (Kbps) per student (weighted median)',
  totalIctGrant: 'School information technology funding',
  childrenInternetAccess: 'Did children have internet access?',
  childrenDeviceAccess: 'Did children have access to a device?',
  deviceAccessYes: 'Children have access to a device',
  deviceAccessNoComputerLaptopOrTablet: 'No computer, laptop, or tablet',
  deviceAccessOwnPersonalComputerLaptopOrTablet:
    'Own personal computer, laptop, or tablet',
  deviceAccessSchoolComputerLaptopOrTablet:
    'School computer, laptop, or tablet',
  deviceAccessSharedComputerLaptopOrTablet:
    'Shared computer, laptop, or tablet',
  gainLossOnRevaluationOfEquityInstrumentsDesignatedAtFairValueThroughOtherComprehensiveIncome:
    'Gain / (loss) on revaluation of equity instruments designated at fair value through other comprehensive income',
  gainLossOnRevaluationOfPropertyPlantAndEquipment:
    'Gain / (loss) on revaluation of property, plant and equipment',
  gainLossOnCurrencyTranslationReserve:
    'Gain / (loss) on currency translation reserve',
  // gainLossOnCashFlowHedges: 'Gain / (loss) on cash flow hedges',
};

export const additionalDataMatcher = (str, value) => {
  const mapper = {
    maximumInternetSpeedPerStudent: `and maximum is ${numberWithCommas(
      value
    )} Kbps`,
    minimumInternetSpeedPerStudent: `The minimum internet speed per student is ${numberWithCommas(
      value
    )} Kbps, `,
  };
  const label = mapper[str];
  if (!label) {
    throw new Error(`Missing label for ${str}`);
  }
  return label;
};

const EntityLabelMapper = {
  plural: {
    Universities: 'Universities',
    Schools: 'Grammar schools',
    'Other Institutions': 'Organisations',
  },
  singular: {
    Universities: 'University',
    Schools: 'Grammar school',
    'Other Institutions': 'Organisation',
  },
};

export const entityLabelMatcher = (str, pluralOrSingular) => {
  if (str.includes('Other')) {
    str = 'Other Institutions';
  }
  const label =
    pluralOrSingular === 'plural'
      ? EntityLabelMapper.plural[str]
      : EntityLabelMapper.singular[str];
  if (!label) {
    throw Error('Missing label for: ' + str);
  }
  return label;
};

export const labelMatcher = (str) => {
  const label = LabelMapper[str];
  if (!label) {
    throw new Error(`Missing label for ${str}`);
  }
  return label;
};



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js